import { Grid, Tabs } from '@mui/material';
import { useState } from 'react';

import {
  Wrapper,
  MenuWrapper,
  SearchIcon,
  SearchWrapper,
  Title,
  SSearchInput,
  StyledBox,
  StyledTab,
} from './styled';
import { General } from './components/general';
import { Support } from './components/support';
import { Payment } from './components/payment';
import { Account } from './components/account';

export const Help = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <Wrapper>
      <Grid container alignItems="center" spacing={2}>
        <Grid xl={7} lg={6} md={12} xs={12} item>
          <Title>
            <div style={{ maxWidth: '312px' }}>Find the answers you need</div>
          </Title>
        </Grid>
        <Grid xl={4.5} lg={6} md={7} sm={8} xs={12} item>
          <SearchWrapper>
            <SSearchInput placeholder="Search an article" />
            <SearchIcon />
          </SearchWrapper>
        </Grid>
      </Grid>
      <MenuWrapper>
        <StyledBox>
          <Tabs
            scrollButtons={false}
            variant="fullWidth"
            value={value}
            onChange={handleChange}
          >
            <StyledTab label="General" />
            <StyledTab label="Support" />
            <StyledTab label="Payment" />
            <StyledTab label="Account" />
          </Tabs>
        </StyledBox>
      </MenuWrapper>
      <TabPanel value={value} index={0}>
        <General />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Support />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Payment />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Account />
      </TabPanel>
    </Wrapper>
  );
};
interface IProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: IProps) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
    >
      {value === index && <>{children}</>}
    </div>
  );
}
